import React, { Component } from 'react';

import reactSelectWithOptions from 'ui/form-elements/ReactSelectHOC';

export const candidateResumeStatusOptions = [
   { value: '', label: 'All Candidates'},
   { value: '1', label: 'Candidates with Resume'},
   { value: '0', label: 'Candidates without Resumes' },
   { value: '2', label: 'New Candidates' }
];

const CandidateResumeStatus = reactSelectWithOptions(
   candidateResumeStatusOptions,
);

CandidateResumeStatus.defaultProps = {
   required: false,
   value: '',
};

export default CandidateResumeStatus;
